export default __webpack_public_path__ + "static/media/q1_step2_2.d6d546a4.png";